import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Icon } from '@material-ui/core';
import SvgIcon from '@material-ui/core/SvgIcon';

import { sendLog, LoggerStatusEnum } from 'ui-model';

const SoundWave = (props) => (
  <SvgIcon height="13px" style={{ width: '103px', height: '13px' }} viewBox="0 0 103 13" width="103px">
    <rect width="1" height="1" rx="0.5" transform="translate(0 6)" fill="inherit" {...props} />
    <rect width="1" height="1" rx="0.5" transform="translate(2 6)" fill="inherit" {...props} />
    <rect width="1" height="1" rx="0.5" transform="translate(4 6)" fill="inherit" {...props} />
    <rect width="1" height="1" rx="0.5" transform="translate(6 6)" fill="inherit" {...props} />
    <rect width="1" height="1" rx="0.5" transform="translate(14 6)" fill="inherit" {...props} />
    <rect width="1" height="3" rx="0.5" transform="translate(8 5)" fill="inherit" {...props} />
    <rect width="1" height="3" rx="0.5" transform="translate(12 5)" fill="inherit" {...props} />
    <rect width="1" height="3" rx="0.5" transform="translate(24 5)" fill="inherit" {...props} />
    <rect width="1" height="3" rx="0.5" transform="translate(26 5)" fill="inherit" {...props} />
    <rect width="1" height="5" rx="0.5" transform="translate(10 4)" fill="inherit" {...props} />
    <rect width="1" height="5" rx="0.5" transform="translate(16 4)" fill="inherit" {...props} />
    <rect width="1" height="5" rx="0.5" transform="translate(18 4)" fill="inherit" {...props} />
    <rect width="1" height="5" rx="0.5" transform="translate(20 4)" fill="inherit" {...props} />
    <rect width="1" height="5" rx="0.5" transform="translate(22 4)" fill="inherit" {...props} />
    <rect width="1" height="1" rx="0.5" transform="translate(80 6)" fill="inherit" {...props} />
    <rect width="1" height="1" rx="0.5" transform="translate(90 6)" fill="inherit" {...props} />
    <rect width="1" height="1" rx="0.5" transform="translate(92 6)" fill="inherit" {...props} />
    <rect width="1" height="1" rx="0.5" transform="translate(94 6)" fill="inherit" {...props} />
    <rect width="1" height="1" rx="0.5" transform="translate(96 6)" fill="inherit" {...props} />
    <rect width="1" height="1" rx="0.5" transform="translate(98 6)" fill="inherit" {...props} />
    <rect width="1" height="1" rx="0.5" transform="translate(100 6)" fill="inherit" {...props} />
    <rect width="1" height="1" rx="0.5" transform="translate(102 6)" fill="inherit" {...props} />
    <rect width="1" height="1" rx="0.5" transform="translate(32 6)" fill="inherit" {...props} />
    <rect width="1" height="1" rx="0.5" transform="translate(52 6)" fill="inherit" {...props} />
    <rect width="1" height="3" rx="0.5" transform="translate(78 5)" fill="inherit" {...props} />
    <rect width="1" height="3" rx="0.5" transform="translate(88 5)" fill="inherit" {...props} />
    <rect width="1" height="3" rx="0.5" transform="translate(34 5)" fill="inherit" {...props} />
    <rect width="1" height="3" rx="0.5" transform="translate(68 5)" fill="inherit" {...props} />
    <rect width="1" height="3" rx="0.5" transform="translate(50 5)" fill="inherit" {...props} />
    <rect width="1" height="3" rx="0.5" transform="translate(56 5)" fill="inherit" {...props} />
    <rect width="1" height="3" rx="0.5" transform="translate(62 5)" fill="inherit" {...props} />
    <rect width="1" height="3" rx="0.5" transform="translate(64 5)" fill="inherit" {...props} />
    <rect width="1" height="5" rx="0.5" transform="translate(36 4)" fill="inherit" {...props} />
    <rect width="1" height="5" rx="0.5" transform="translate(70 4)" fill="inherit" {...props} />
    <rect width="1" height="5" rx="0.5" transform="translate(46 4)" fill="inherit" {...props} />
    <rect width="1" height="5" rx="0.5" transform="translate(38 4)" fill="inherit" {...props} />
    <rect width="1" height="5" rx="0.5" transform="translate(40 4)" fill="inherit" {...props} />
    <rect width="1" height="5" rx="0.5" transform="translate(54 4)" fill="inherit" {...props} />
    <rect width="1" height="5" rx="0.5" transform="translate(58 4)" fill="inherit" {...props} />
    <rect width="1" height="5" rx="0.5" transform="translate(72 4)" fill="inherit" {...props} />
    <rect width="1" height="5" rx="0.5" transform="translate(74 4)" fill="inherit" {...props} />
    <rect width="1" height="5" rx="0.5" transform="translate(76 4)" fill="inherit" {...props} />
    <rect width="1" height="5" rx="0.5" transform="translate(30 4)" fill="inherit" {...props} />
    <rect width="1" height="5" rx="0.5" transform="translate(66 4)" fill="inherit" {...props} />
    <rect width="1" height="7" rx="0.5" transform="translate(28 3)" fill="inherit" {...props} />
    <rect width="1" height="7" rx="0.5" transform="translate(42 3)" fill="inherit" {...props} />
    <rect width="1" height="7" rx="0.5" transform="translate(86 3)" fill="inherit" {...props} />
    <rect width="1" height="7" rx="0.5" transform="translate(60 3)" fill="inherit" {...props} />
    <rect width="1" height="5" rx="0.5" transform="translate(82 4)" fill="inherit" {...props} />
    <rect width="1" height="7" rx="0.5" transform="translate(84 3)" fill="inherit" {...props} />
    <rect width="1" height="9" rx="0.5" transform="translate(48 2)" fill="inherit" {...props} />
    <rect width="1" height="13" rx="0.5" transform="translate(44)" fill="inherit" {...props} />
  </SvgIcon>
);

const styles = {
  controls: {
    display: 'inline-block',
    float: 'left',
    height: 18,
    transition: 'opacity 1000ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    position: 'relative',
    overflow: 'hidden',
  },
  icon: {
    cursor: 'pointer',
    float: 'left',
    fontSize: 13,
    position: 'relative',
    top: 1,
  },
  root: {
    display: 'inline-block',
    float: 'right',
  },
  soundWave: {
    button: {
      cursor: 'pointer',
      display: 'inline-block',
      height: 18,
      margin: '0px 8px',
      position: 'absolute',
      width: 103,
      zIndex: 10,
    },
    current: {
      display: 'inline-block',
      margin: '0px 8px',
      maxWidth: 103,
      overflow: 'hidden',
      position: 'absolute',
      transition: 'all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      zIndex: 5,
    },
    duration: {
      display: 'inline-block',
      margin: '0px 8px',
      width: 103,
    },
    root: {
      display: 'inline-block',
    },
  },
  text: {
    display: 'inline-block',
    float: 'left',
    textAlign: 'center',
    width: 70,
  },
  time: {
    display: 'inline-block',
    textAlign: 'center',
    width: 26,
  },
};

class VoicePlayer extends Component {
  constructor(props) {
    super(props);

    this.handleCurrentTimeChange = this.handleCurrentTimeChange.bind(this);
    this.handleDurationUpdate = this.handleDurationUpdate.bind(this);
    this.handlePlayStopEvent = this.handlePlayStopEvent.bind(this);
    this.handlePlayPauseButtonClick = this.handlePlayPauseButtonClick.bind(this);

    this.state = {
      currentTime: -1,
      duration: 0,
      interval: null,
      isPlaying: false,
      played: false,
    };
  }

  handleCurrentTimeChange(event, voiceId) {
    const { duration } = this.state;
    const button = event.currentTarget;
    const audio = document.getElementById(voiceId);

    if (button) {
      const offsetWidth = event.clientX - (event.target.offsetParent.offsetLeft + button.offsetLeft) || 0;
      const offsetWidthPercent = (offsetWidth * 100) / button.offsetWidth;
      const currentTime = parseInt((duration * offsetWidthPercent) / 100, 10);

      audio.currentTime = currentTime;
      this.setState({ ...this.state, currentTime });
    }
  }

  handleDurationUpdate(id) {
    const audio = document.getElementById(id);

    if (audio) this.setState({ ...this.state, duration: audio.duration });
  }

  handlePlayStopEvent(id, play) {
    const { interval } = this.state;
    const audio = document.getElementById(id);

    if (audio) {
      if (play) {
        if (!interval) {
          const timer = setInterval(() => {
            this.setState({ ...this.state, currentTime: audio.currentTime });
          }, audio.playbackRate * 1000);

          this.setState({
            duration: audio.duration,
            isPlaying: play,
            interval: timer,
            played: true,
          });
        }
      } else {
        clearInterval(interval);
        this.setState({
          currentTime: audio.currentTime,
          duration: audio.duration,
          isPlaying: play,
          interval: null,
        });
      }
    }
  }

  handlePlayPauseButtonClick(id) {
    const { isPlaying } = this.state;
    const audio = document.getElementById(id);

    if (audio) {
      if (!isPlaying) {
        audio.play();
      } else if (audio.play) {
        audio
          .play()
          .then((_) => audio.pause())
          .catch((error) =>
            sendLog('Error on VoicePlayer component play/pause', { errorStack: error }, LoggerStatusEnum.error),
          );
      }
    }
  }

  renderDuration() {
    const { duration } = this.state;

    return (
      <div style={styles.time}>
        {moment()
          .startOf('day')
          .add(parseInt(duration, 10), 'second')
          .format('m:ss')}
      </div>
    );
  }

  renderSoundWave(voiceId) {
    const { currentTime, duration } = this.state;
    const currentWidth = parseInt((103 * ((currentTime * 100) / duration)) / 100, 10) || 0;

    return (
      <div style={styles.soundWave.root}>
        <div
          className="soundwave-button"
          onClick={(event) => this.handleCurrentTimeChange(event, voiceId)}
          style={styles.soundWave.button}
        />
        <div style={{ ...styles.soundWave.current, width: currentWidth }}>
          <SoundWave />
        </div>
        <div style={styles.soundWave.duration}>
          <SoundWave opacity={0.5} />
        </div>
      </div>
    );
  }

  renderCurrentTime() {
    const { currentTime, duration } = this.state;
    let time = duration - currentTime > 1 ? currentTime + 1 : currentTime;

    if (time > duration) time = duration;

    return (
      <div style={styles.time}>
        {moment()
          .startOf('day')
          .add(parseInt(time, 10), 'second')
          .format('m:ss')}
      </div>
    );
  }

  renderControls(voiceId) {
    const { isPlaying, played } = this.state;
    const textStyle = {
      ...styles.text,
      display: isPlaying || played ? 'none' : 'inline-block',
    };
    const controlsStyle = {
      ...styles.controls,
      opacity: isPlaying || played ? 1 : 0,
      width: isPlaying || played ? 171 : 0,
    };

    return (
      <div style={styles.controls}>
        <div style={textStyle}>Play message</div>
        <div style={controlsStyle}>
          {this.renderCurrentTime()}
          {this.renderSoundWave(voiceId)}
          {this.renderDuration()}
        </div>
      </div>
    );
  }

  renderPlayPauseButton(voiceId) {
    const { color } = this.props;
    const { isPlaying } = this.state;
    const iconStyle = {
      ...styles.icon,
      color: color || '#fff',
    };

    return (
      <Icon style={iconStyle} onClick={() => this.handlePlayPauseButtonClick(voiceId)}>
        {`${isPlaying ? 'pause' : 'play'}_circle_filled`}
      </Icon>
    );
  }

  renderAudioObject(voiceId, audio) {
    return (
      <audio
        id={voiceId}
        onDurationChange={() => this.handleDurationUpdate(voiceId)}
        onPlaying={() => this.handlePlayStopEvent(voiceId, true)}
        onPause={() => this.handlePlayStopEvent(voiceId, false)}
        onWaiting={() => this.handlePlayStopEvent(voiceId, false)}
      >
        <source src={audio} type="audio/mpeg" />
      </audio>
    );
  }

  render() {
    const { media } = this.props;
    const rootStyle = { ...styles.root };
    const random = Math.random() / new Date().valueOf();
    const voiceId = `voice_${random}`;

    return (
      <div style={rootStyle}>
        {this.renderAudioObject(voiceId, media)}
        {this.renderPlayPauseButton(voiceId)}
        {this.renderControls(voiceId)}
      </div>
    );
  }
}

VoicePlayer.propTypes = {
  color: PropTypes.string,
  media: PropTypes.string,
};

export default VoicePlayer;
